import { render, staticRenderFns } from "./FormEdit.vue?vue&type=template&id=211277e5&"
import script from "./FormEdit.vue?vue&type=script&lang=js&"
export * from "./FormEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('211277e5')) {
      api.createRecord('211277e5', component.options)
    } else {
      api.reload('211277e5', component.options)
    }
    module.hot.accept("./FormEdit.vue?vue&type=template&id=211277e5&", function () {
      api.rerender('211277e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/reporting-channel/screening/FormEdit.vue"
export default component.exports